import React from 'react';

import { Section } from 'jbc-front/components/Form';
import { getOptionLabel, numToStr, display, currency } from 'src/utils/Utils';
import tableStyles from '../styles/GeneralTableInfo.scss';
import { useTranslation } from 'react-i18next';

const CommutingByCarShow = ({ commutingItem, commutingDistances }) => {
  const { t, i18n } = useTranslation();
  return (
    <div>
      <Section title="車">
        <table className={tableStyles.mTablePersonal}>
          <tbody>
            <tr>
              <th>{t('features.Employees.components.CommutingByCarShow.departure_place')}：</th>
              <td>{display(commutingItem.firstStop)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.CommutingByCarShow.destination')}：</th>
              <td>{display(commutingItem.lastStop)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.CommutingByCarShow.one_way_commuting_distance')}：</th>
              <td>{display(getOptionLabel(commutingItem.commutingDistance)(commutingDistances))}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.CommutingByCarShow.payment_amount')}：</th>
              <td>{currency(numToStr(commutingItem.paymentAmount))}</td>
            </tr>
          </tbody>
        </table>
      </Section>
    </div>
  );
};

export default CommutingByCarShow;
